import { Box, Card, Stack, Text } from '@ltvco/refresh-lib/theme';
import { ReactNode } from 'react';

interface BaseCardComponentProps {
  title: string;
  children: ReactNode;
}

export function BaseCardComponent({ title, children }: BaseCardComponentProps) {
  return (
    <Card
      variant="outlined"
      sx={{ borderRadius: '12px', p: 0, height: '100%' }}
    >
      {/* Main heading */}
      <Stack
        justifyContent="center"
        sx={{
          backgroundColor: 'background.default',
          borderBottom: '1px solid',
          borderColor: 'divider',
          px: 3,
          py: 2,
          minHeight: 56,
        }}
      >
        <Text variant="h5" fontWeight="bold" sx={{ margin: 0 }}>
          {title}
        </Text>
      </Stack>

      {/* Content */}
      <Box sx={{ p: 3 }}>{children}</Box>
    </Card>
  );
}
